import getGroupInfoFromCache from './getGroupInfoFromCache';

export default getGroupInfoFromCache;
